import type { CSSProperties } from 'react'

interface SliderFieldProps {
    id: string
    label: string
    value: number
    min: number
    max: number
    step: number
    onChange: (value: number) => void
    format: (value: number) => string
}

export const SliderField = ({ id, label, value, min, max, step, onChange, format }: SliderFieldProps) => {
    const percent = ((value - min) / (max - min)) * 100

    return (
        <div>
            <div className='flex items-baseline justify-between gap-3'>
                <label htmlFor={id} className='text-[13px] text-cream/65'>
                    {label}
                </label>

                <output htmlFor={id} className='text-[15px] font-medium tabular-nums tracking-[-0.01em] text-cream'>
                    {format(value)}
                </output>
            </div>

            <input
                id={id}
                type='range'
                min={min}
                max={max}
                step={step}
                value={value}
                onChange={event => onChange(Number(event.target.value))}
                aria-valuetext={format(value)}
                className='range mt-2'
                style={{ '--pct': `${Math.min(100, Math.max(0, percent))}%` } as CSSProperties}
            />
        </div>
    )
}
